<template>
    <div>
        <h2>Comments:</h2>
        <div class="comment" v-for="comment in list">
            <span class="author">{{comment.author}}:</span>
            <span class="delete-button" v-show="comment.can_delete" @click="del(comment.id)">✕</span>
            <vue-markdown :source="comment.text" :html=false :linkify=false
                          :anchorAttributes="{target:'_blank',rel:'nofollow'}"
                          :postrender="cl"
            ></vue-markdown>
            <span class="date">{{comment.created}}</span>
        </div>
        <form class="comment-form" @submit.prevent="submit">
            <input type="hidden" name="entity_name" :value="entity_name" />
            <input type="hidden" name="entity_id" :value="entity_id" />
            <div class="form-group">
                <textarea class="form-control" name="text" placeholder="use Markdown" v-model="text" required></textarea>
                <span class="error">{{errors.text}}</span>
                <vue-markdown :source="text" :html=false :linkify=false
                              :anchorAttributes="{target:'_blank',rel:'nofollow'}"
                              :postrender="cl"
                ></vue-markdown>
            </div>
            <div class="row form-group">
                <div class="col-6">
                    <input class="form-control" type="text" name="author" placeholder="your name" required/>
                    <span class="error">{{errors.author}}</span>
                </div>
                <div class="col-6">
                    <input class="form-control" type="submit" :disabled="loading" />
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        name: "comment",
        props: ['entity_name', 'entity_id'],
        data: function () {
            return {
                loading: false,
                list: [],
                errors: {},
                text: ''
            }
        },
        methods: {
            load() {
                let _this = this;
                if (_this.loading) {
                    return;
                }
                _this.loading = true;
                let url = '/comment/list?entity_name=' + _this.entity_name +
                        '&entity_id=' + _this.entity_id;
                _this.axios.get(url).then(function (response) {
                    _this.list = response.data.list;
                    _this.loading = false;
                })
            },
            submit(ev) {
                let _this = this;
                if (_this.loading) {
                    return;
                }
                _this.loading = true;
                let data = new FormData(ev.target);
                data.append('_csrf', document.getElementsByName('csrf-token')[0].content);
                _this.axios.post('/comment/create', data).then(function (response) {
                    _this.loading = false;
                    _this.load();
                    if (response.data.comment.id > 0) {
                        ev.target.reset();
                        _this.text = '';
                    } else {
                        _this.errors = response.data.comment.errors || {};
                    }
                })
            },
            del(id) {
                let _this = this;
                if (_this.loading) {
                    return;
                }
                _this.loading = true;
                let url = '/comment/delete?id=' + id;
                _this.axios.get(url).then(function (response) {
                    _this.loading = false;
                    _this.load();
                })
            },
            cl: s => s.replace(/<h[12]/, '<h3')
        },
        mounted() {
            this.load();
        }
    }
</script>

<style lang="scss">
</style>